import { Point, Vertices } from '../models/location.model';

export class MapUtils {
    static getImageBoundsForMap(facilityBounds: Vertices, map: { width: number, height: number }, image: { width: number, height: number }): google.maps.LatLngBoundsLiteral {
        const mapWidth = map.width;
        const mapHeight = map.height;
        const imageAspectRatio = image.height / image.width;
        let adjustedImageWidth = image.width;
        let adjustedImageHeight = image.height;
        if (image.width > mapWidth) {
            adjustedImageWidth = mapWidth;
            adjustedImageHeight = mapWidth * imageAspectRatio;
        } else if (image.height > mapHeight) {
            adjustedImageHeight = mapHeight;
            adjustedImageWidth = mapHeight / imageAspectRatio;
        }

        const nPixel = (mapHeight - adjustedImageHeight) / 2;
        const wPixel = (mapWidth - adjustedImageWidth) / 2;
        const sPixel = nPixel + adjustedImageHeight;
        const ePixel = wPixel + adjustedImageWidth;
        const mapHeightRange: [number, number] = [0, mapHeight];
        const mapWidthRange: [number, number] = [0, mapWidth];

        const nBound = this.convertRange(nPixel, mapHeightRange, [facilityBounds[1][1], facilityBounds[0][1]]);
        const sBound = this.convertRange(sPixel, mapHeightRange, [facilityBounds[1][1], facilityBounds[0][1]]);
        const wBound = this.convertRange(wPixel, mapWidthRange, [facilityBounds[0][0], facilityBounds[1][0]]);
        const eBound = this.convertRange(ePixel, mapWidthRange, [facilityBounds[0][0], facilityBounds[1][0]]);

        return {
            north: nBound,
            south: sBound,
            east: eBound,
            west: wBound,
        };
    }

    static toGoogleBounds(bounds: number[][]): google.maps.LatLngBounds {
        const sw = new google.maps.LatLng(bounds[0][1], bounds[0][0]);
        const ne = new google.maps.LatLng(bounds[1][1], bounds[1][0]);
        return new google.maps.LatLngBounds(sw, ne);
    }

    static convertRange(value, r1, r2): number {
        return (value - r1[0]) * (r2[1] - r2[0]) / (r1[1] - r1[0]) + r2[0];
    }

    static isValidLocation(location: Point | number[]) {
        return !!(location && location[0] && location[1]);
    }
}
